<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>静态资源</span>
        </div>
        <el-card style="margin-bottom: 15px;">
          <proxyConfig />
        </el-card>

        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button v-permisaction="['config:staticConfig:add']" type="primary" @click="onSubmit()">保存</el-button>
            <el-upload
              ref="upload2"
              style="display: inline-block;margin-left: 10px"
              class="upload-demo"
              :action="sys_app_logoAction"
              accept="zip,7z"
              :limit="1"
              :on-success="(res)=>{return importUploadSuccess(res,-1,-1)}"
              :before-upload="beforeUpload2"
              :headers="headers"
            >
              <el-button v-permisaction="['config:staticConfig:upload']" :loading="loading" icon="el-icon-upload2" type="primary">压缩包上传</el-button>
            </el-upload>
            <el-button v-permisaction="['config:staticConfig:add']" style="margin-left: 10px;" type="primary" @click="addCate()">+分类</el-button>
          </el-form-item>

          <el-card v-for="(c, k) in cate" :key="k">
            <div slot="header" class="clearfix">
              <span>
                <el-form-item label="名称">
                  <el-input v-model.trim="c.name" placeholder="名称" />
                </el-form-item>
                <el-form-item label="KEY">
                  <el-input v-model="c.key" placeholder="KEY" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="saveCate">保存分类</el-button>
                </el-form-item>
                <el-button v-if="c.save && c.key !== ''" v-permisaction="['config:staticConfig:add']" type="primary" @click="add(c.key)">+</el-button>
                <el-button v-if="c.save && getCidLen(c.key)" v-permisaction="['config:staticConfig:add']" type="warning" @click="move( c.key)">移动到</el-button>
                <el-form-item v-if="c.save && getCidLen(c.key)" style="margin-left: 10px">
                  <el-select v-model="mid" placeholder="请选择">
                    <el-option
                      v-for="item in cate"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                      :disabled="item.key === c.key"
                    />
                  </el-select>
                </el-form-item>
                <el-button v-if="c.save && c.key !== ''" v-permisaction="['config:staticConfig:add']" :loading="loading" type="success" @click="makeZip(c.key)">生成Zip</el-button>
              </span>
            </div>
            <el-row v-for="(item, index) in formData" :key="k+index">
              <span v-if="item.cate === c.key">
                <el-form-item>
                  <el-checkbox v-model="cid[c.key][item.config]" label="" />
                </el-form-item>
                <el-form-item label="KEY">
                  <el-input v-model="item.config" style="width: 300px;" placeholder="KEY" />
                </el-form-item>
                <el-form-item label="路径">
                  <el-input v-model="item.path" readonly style="width: 400px;" placeholder="路径" />
                </el-form-item>
                <el-form-item label="备注">
                  <el-input v-model="item.mark" style="width: 150px;" placeholder="备注" />
                </el-form-item>
                <el-form-item v-if="item._id > 0" label="上传">
                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    :action="sys_app_logoAction"
                    accept="zip,xlsx"
                    :limit="1"
                    :on-success="(res)=>{return importUploadSuccess(res, index, item.config)}"
                    :before-upload="beforeUpload"
                    :headers="headers"
                  >
                    <el-button v-permisaction="['config:staticConfig:upload']" icon="el-icon-upload2" type="primary">上传</el-button>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:staticConfig:del']" type="danger" @click="del(item.config, item._id, index)">删除</el-button>
                </el-form-item>
              </span>
            </el-row>
          </el-card>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  delStaticcfg,
  getStaticList, makeStaticJson, makeZip, ossSyncS3,
  pushObjectCache, refreshPath,
  updateStaticCfg,
  uploadJson
} from '@/api/config/staticcfg'
import proxyConfig from '@/views/config/static-config/components/proxyConfig.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
export default {
  name: 'StaticConfigV2',
  components: {
    proxyConfig
  },
  data() {
    return {
      cid: {},
      mid: '',
      time: 0,
      env: process.env.VUE_APP_ENV,
      loading: false,
      loading2: false,
      refreshParam: {
        type: 'Directory',
        path: ''
      },
      refreshTypes: [
        { label: '文件刷新', value: 'File' },
        { label: '目录刷新', value: 'Directory' }
      ],
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      cateKey: 'StaticCate',
      cate: [
        { name: '默认', key: 'default' }
      ],
      formData: [
        {
          _id: 0,
          'config': '',
          'path': '',
          'mark': '',
          'cate': 'default'
        }
      ]
    }
  },
  created() {
    this.getCate()
    this.getTables()
  },
  mounted() {
    // console.log('load', this.$refs.upload)
  },
  methods: {
    refresh() {
      const paths = this.refreshParam.path.split('\n')
      for (const i in paths) {
        const path = paths[i]
        const parts = path.split('/')
        const fileName = parts[parts.length - 1]
        if (fileName.includes('.')) {
          if (this.refreshParam.type === 'Directory') {
            this.msgError('目录刷新不能包含文件')
            return
          }
        } else {
          if (this.refreshParam.type === 'File') {
            this.msgError('文件刷新需要指定文件名')
            return
          }
        }
      }
      this.loading = true
      refreshPath({ data: this.refreshParam.path, type: this.refreshParam.type }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.loading = false
        } else {
          this.msgError(res.msg)
          this.loading = false
        }
      })
    },
    getCidLen(key) {
      for (const i in this.cid[key]) {
        if (this.cid[key][i]) {
          return true
        }
      }
      return false
    },
    saveCate() {
      for (const i in this.cate) {
        const val = this.cate[i]
        if (val.name === '') {
          this.msgError('分类名称不能为空')
          return
        }

        if (val.key === '') {
          this.msgError('分类KEY不能为空')
          return
        }
      }
      const data = JSON.stringify(this.cate)
      console.log('saveCate', data)
      updateCommonCfg({ name: this.cateKey, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getCate()
          this.getTables()
        }
      })
    },
    onSubmit(path = null, syncOss = true) {
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateStaticCfg({ data: data, name: this.time }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          if (path) {
            pushObjectCache({ data: path }).then(r => {
              if (r.code !== 200) {
                this.msgError(r.msg)
              }
            })
          } else {
            if (syncOss) {
              this.updateStatic()
            }
          }

          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getStaticList().then(res => {
        if (res.code === 200) {
          this.formData = []
          res.data.list.forEach(item => {
            this.formData.push({ _id: 1, config: item.config, cate: item.cate, path: item.path, mark: item.mark })
          })
          this.time = res.data.time
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getCate() {
      this.cate = []
      getCommonCfg({ name: this.cateKey }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            val.save = true
            this.$set(this.cid, val.key, [])
            this.cate.push(val)
          }
        }
      })
    },
    addCate() {
      this.cate.unshift({
        'name': '',
        'key': '',
        'zip': '',
        save: false
      })
    },
    move(key) {
      if (this.mid === '') {
        this.msgError('请选择移动分类')
        return false
      }
      const moveCid = []
      for (const i in this.cid[key]) {
        const val = this.cid[key][i]
        if (val) {
          // console.log('vl', i, val)
          moveCid.push(i)
        }
      }

      if (moveCid.length <= 0) {
        this.msgError('没有可以移动的数据')
        return false
      }

      console.log('moveCid', moveCid)
      if (moveCid.length > 0) {
        for (const i in moveCid) {
          this.formData.forEach((item, index) => {
            if (item.config === moveCid[i]) {
              this.formData[index].cate = this.mid
            }
          })
        }

        this.mid = ''
        this.cid[key] = []
        this.onSubmit(null, false)
      }
    },
    add(name) {
      this.formData.unshift({
        _id: 0,
        'config': '',
        'path': '',
        'mark': '',
        'cate': name
      })
    },
    makeZip(name) {
      this.loading = true
      makeZip({ name: name }).then(res => {
        if (res.code === 200) {
          this.loading = false
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(key, _id, index) {
      if (_id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delStaticcfg({ data: key }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.getTables()
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData = this.formData.filter((item, key) => {
          return key !== index
        })
      }
    },
    beforeUpload2(file) {
      var extension = file.name.split('.').pop()
      if (extension !== '7z' && extension !== 'zip') {
        this.msgError('只允许上传.7z,.zip文件')
        return false
      }
      return true
    },
    beforeUpload(file) {
      console.log('extension', file.type)
      // application/x-zip-compressed
      if (file.type !== 'application/json' && file.type !== 'application/x-zip-compressed' && file.type !== 'application/zip') {
        this.msgError('只允许上传zip,json文件')
        return false
      }
      return true
    },
    importUploadSuccess(response, index, key) {
      this.loading = true
      const _this = this
      this.$refs.upload.forEach(file => {
        file.clearFiles()
      })
      let typ = 0
      if (index === -1 && key === -1) {
        typ = -1
        this.$refs.upload2.clearFiles()
      }
      uploadJson({ data: response.data.path, name: key, type: typ, Id: this.time }).then(res => {
        _this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
          if (typ !== -1) {
            this.formData.forEach((item, index) => {
              if (item.config === key) {
                this.formData[index].path = res.data
              }
            })
            this.onSubmit(res.data)
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    updateStatic() {
      this.$confirm('是否同步静态配置到S3?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        makeStaticJson().then(res => {
          if (res.code === 200) {
            this.msgSuccess('更新成功')
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    ossAsyncS3() {
      this.$confirm('此操作将OSS数据同步到S3, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading2 = true
        ossSyncS3().then(res => {
          this.loading2 = false
          if (res.code === 200) {
            this.msgSuccess(res.msg)
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
